import React from "react";
import { useOutletContext, useParams } from "react-router";
import UserJoinForm from "../../login/component/userJoinForm";
import { Container } from "../login/styled";

const ShoppingJoin = () => {
  const { url } = useParams();
  const { homepageInfo, theme } = useOutletContext();
  return (
    <Container className={`theme-${theme}`}>
      <UserJoinForm homepageInfo={homepageInfo} url={url} />
    </Container>
  );
};

export default ShoppingJoin;
